import { Minus, Plus } from 'lucide-react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useMap } from 'react-map-gl/mapbox';

import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

const ZoomButtons = () => {
  const { t } = useTranslation();
  const { current: map } = useMap();

  const onZoomIn = useCallback(() => {
    const currentZoom = map?.getZoom() ?? 0;
    map?.zoomTo(currentZoom + 1);
  }, [map]);

  const onZoomOut = useCallback(() => {
    const currentZoom = map?.getZoom() ?? 0;
    map?.zoomTo(currentZoom - 1);
  }, [map]);

  return (
    <div className="flex flex-col">
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <Button
              onClick={onZoomIn}
              className="w-10 h-10 p-2 rounded-tl-[50%] rounded-tr-[50%] rounded-b-none"
              name="zoom-plus"
              aria-label="Zoom in"
            >
              <Plus className="size-6" strokeWidth={2.4} />
            </Button>
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p>{t('common.zoom_in')}</p>
        </TooltipContent>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <Button
              onClick={onZoomOut}
              className="w-10 h-10 p-2 rounded-bl-[50%] rounded-br-[50%] rounded-t-none shadow-sm border-t border-l-border"
              name="zoom-minus"
              aria-label="Zoom out"
            >
              <Minus className="size-6" strokeWidth={2.4} />
            </Button>
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p>{t('common.zoom_out')}</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
};

export default ZoomButtons;
